import script from "./FactureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FactureView.vue?vue&type=script&setup=true&lang=ts"

import "./FactureView.vue?vue&type=style&index=0&id=0e756b7e&lang=scss&scoped=true"
import "./FactureView.vue?vue&type=style&index=1&id=0e756b7e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e756b7e"]])

export default __exports__